export enum HaghighiHoghooghiEnum {
  HAGHIGHI = 0,
  HOGHOOGHI = 1,
}
